export const isObject = (value: any): value is Object =>
  typeof value === 'object' && value !== null;

export const isString = (value: any): value is string =>
  typeof value === 'string';
